export class MyPlan {
    startDate: string;
    endDate: string;
    timezone: string;
    guests: Array<string> = [];
    primaryGuest: string;
}
